import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .items-wrapper {
    > div {
      border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
    }
  }

  .edit {
    cursor: pointer;
  }

  .subscription {
    &__data {
      max-width: 60%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      ${bp('sm')`
        flex-wrap: wrap;
        max-width: 100%;

        > div {
          width: 100%;
        }
      `}

      &__shipping {
        display: flex;
        align-items: center;
        position: relative;

        > div:nth-child(1) {
          margin-right: 20px;
        }

        p {
          max-width: 220px;
        }
      }
    }

    &__item {
      display: flex;
      justify-content: space-between;
      padding: 15px 0 15px;
      ${bp('sm')`
        flex-wrap: wrap;
      `}

      .item {
        &__info {
          display: flex;
        }

        &__name {
          font: ${font('default', 'bold', '16px/1.5')};
          margin-bottom: 10px;
        }

        &__image {
          width: 120px;
          height: 80px;
          border: 1px solid ${props => props.theme.palette.general.dark};
          margin-right: 10px;

          span {
            display: block;
            width: 120px;
            height: 80px;
            background: no-repeat 50% 50% / contain;
          }
        }

        &__shipment {
          margin-bottom: 10px;
        }

        &__price {
          margin: 0 60px;
          font-size: 15px;
          ${bp('sm')`
            margin: 0 40px 5px 40px;
            width: 100%;
          `}
        }

        &__extra {
          ${bp('sm')`
            margin-left: auto;
          `}
          > div {
            text-align: right;
            margin-bottom: 10px;
          }
        }
      }
    }

    &__action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
      padding: 10px;
      flex-wrap: wrap;

      > div {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        ${bp('sm')`
          justify-content: center;
        `}
      }

      button {
        margin: 5px;
        ${bp('sm', 'min-with')`
          &:last-child {
            margin-left: auto;
          }
        `}
      }

      .cancel {
        background-color: ${props => props.theme.palette.state.danger};
        border-color: ${props => props.theme.palette.state.danger};
      }

      .pause {
        background-color: ${props => props.theme.palette.primary.beta};
        border-color: ${props => props.theme.palette.primary.beta};
      }
    }

    &__bottom-note {
      font: ${font('default', 'light', '14px/1.5')};

      a {
        ${props => props.theme.css.link};
      }
    }

    &__content {
      border-top: 1px solid ${props => props.theme.palette.general.greyLight};
      border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
    }

    svg {
      width: 16px;
      fill: ${props => props.theme.palette.primary.alphaDark};
      margin-left: 5px;
    }
  }
`
